<template lang="html">
  <div :class="{clueFilter: true,bottom: !showFilters}">
    <div class="headline">
      <span class="label gray">已选：</span>
      <div class="cates">
        <div class="cateWrapper" v-if="keySearchIn.length > 0">
          <div v-if="item.key_words" v-for="(item,index) in keySearchIn" :key="index" class="cate">
            <span class="type">{{item.key_words || item}}</span>
            <img src="@assets/img/common/del.svg" alt="del" @click="delKeyWordIn(index)">
          </div>
        </div>
        <div class="cateWrapper" v-if="keySearchOut.length > 0">
          <div v-if="item" v-for="(item,index) in keySearchOut" :key="index" class="cate">
            <span class="type">-{{item.key_words || item}}</span>
            <img src="@assets/img/common/del.svg" alt="del" @click="delKeyWordOut(index)">
          </div>
        </div>
        <div class="cateWrapper" v-for="(s, i) in filters" :key="i">
          <div class="cate" v-if="s.list && s.list.filter(sc2 => {if (sc2.selected) return sc2}).length > 0" :title="`${s.list.filter(sc => {if (sc.selected) return sc}).map(sci => sci.title).join('/')}`">
            <span class="type">{{`${s.title}: ${s.list.filter(sc => {if (sc.selected) return sc}).map(sci => sci.title).join('/')}`}}</span>
            <img src="@assets/img/common/del.svg" alt="del" @click="delCate(s)">
          </div>
          <div class="cate" v-for="(s2, i2) in s.list" :key="i2" v-if="s2.selected && s2.list && s2.list.filter(sci2 => {if (sci2.selected) return sci2}).length > 0" :title="`${s2.list && s2.list.filter(sc2 => {if (sc2.selected) return sc2}).map( sci2 => sci2.title).join('/')}`">
            <span class="type">{{`${s2.title}: ${s2.list && s2.list.filter(sc2 => {if (sc2.selected) return sc2}).map( sci2 => sci2.title).join('/')}`}}</span>
            <img src="@assets/img/common/del.svg" alt="del" @click="delCate(s2)">
          </div>
        </div>
        <div class="cateWrapper" v-if="timeDayData.list.filter(i => {if (i.selected) return i}).length > 0">
          <div class="cate" :title="`${timeDayData.list && timeDayData.list.filter(i => {if (i.selected) return i}).map( i => i.title).join('/')}`">
            <span class="type">{{`${timeDayData.title}: ${timeDayData.list.filter(i => {if (i.selected) return i}).map( i => i.title).join('/')}`}}</span>
            <img src="@assets/img/common/del.svg" alt="del" @click="delTimeData()">
          </div>
        </div>
      </div>
      <div class="toggler" @click="toggle()">
        <img src="@assets/img/common/filter.svg" alt="filter">
        <span>{{showFilters?'收起筛选' : '展开筛选'}}</span>
        <img :src="showFilters ? icons.upward : icons.downward" alt="down">
      </div>
    </div>
    <p class="line" v-show="showFilters"></p>
    <div class="filters" v-show="showFilters" v-for="(f, i) in filters" :key="i">
      <div :class="{filter: true, mb_20: !f.source_type}">
        <span class="label">
          {{f.title}}
        </span>
        <div :class="{items: true, overflow: f.expand}" :ref="`items${i}`">
          <div :class="{item: true, active: si.selected}" v-for="(si, sd) in f.list" :key="sd" @click="selectItem(si,`items${i}`)">
            {{si.title}}
          </div>
        </div>
        <div class="expander" @click="changeExpand(f, `items${i}`)" :ref="`expander${i}`" v-show="calcExpendWidth(`items${i}`, `expander${i}`)">
          <img :src="f.expand ? icons.upward : icons.downward" alt="icon">
        </div>
        <div class="set" v-if="f.source_type" @click="openSet(f.source_type, $route.params.id)">
          订阅
        </div>
      </div>
      <div class="filter mb_20_new pb_20_new" v-for="(s, d) in f.list" :key="d" v-if="s.list && s.list.length > 0 && s.selected">
        <span class="label">
          {{s.title}}
        </span>
        <div :class="{items: true, overflow: s.expand}" :ref="`filters${d}`">
          <div :class="{item: true, active: c.selected}" v-for="(c, ci) in s.list" :key="ci" @click="selectItem(c,`filters${d}`)">
            {{c.title}}
          </div>
        </div>
        <!-- <div :ref="`expander1${d}`" class="expander" @click="changeExpand(s, `filters${d}`)" v-show="s.list.length > 10 && calcExpendWidth(`filters${d}`,`expander1${d}`)"> -->
        <div :ref="`expander1${d}`" class="expander" @click="changeExpand(s, `filters${d}`)" v-show="calcExpendWidth(`filters${d}`,`expander1${d}`)">
          <img :src="s.expand ? icons.upward : icons.downward" alt="xiala">
        </div>
        <p class="seperator"></p>
      </div>
    </div>
    <div class="filters" v-show="showFilters && hasDay">
      <div class="filter">
        <span class="label">
          发布时间
        </span>
        <div class="items" v-show="!this.start && !this.end">
          <div :class="{item: true, active: day.key === dd.key}" v-for="(dd, di) in days" :key="di" @click="selectDay(dd)">
            {{dd.title}}
          </div>
        </div>
        <date-picker style="margin-bottom: 20px;" v-show="!this.day.key" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
      </div>
    </div>
    <clueSources ref="clueSources" />
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import clueSources from '@components/clueSources'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'clueFilter',
  components: { clueSources, DatePicker },
  data() {
    return {
      keySearchIn: [],
      keySearchOut: [],
      listSearch: [],
      hasDay: false,
      cates: [],
      showFilters: true,
      icons: {
        downward: require('@assets/img/common/xiala.svg'),
        upward: require('@assets/img/common/upward.svg')
      },
      filters: [],
      filterOptions: {},
      days: [
        {
          title: '今天',
          key: 1
        },
        {
          title: '昨天',
          key: 2
        },
        {
          title: '前一周',
          key: 3
        }
      ],
      day: {},
      datePicker: '',
      start: '',
      end: '',
      selectedTag: '',
      timeDayData: {
        title: '发布时间',
        list: []
      }
    }
  },
  props: {
    'type': {
      type: Number,
      required: true
    },
    'list_search': {
      type: Array
    },
    'keySearch': {
      type: Object
    }
  },
  watch: {
    list_search: function(n) {
      this.getData()
    },
    type: function(n) {
      // this.getData()
      console.log('type', n)
    },
    filters: function() {
      if(this.filters.length > 0){
        this.filters.forEach((el,key) => {
          this.calcExpendWidth(`items${key}`, `expander${key}`)
        })
      }
    },
    keySearch(to) {
      console.log(to)
      let toin = [];
      if(to.in.length == 0){
        toin= [{
          search_option: 0,
          key_words: ''
        }]
      }else{
        let arr = []
        to.in.forEach(el => {
            arr.push({
              key_words: el.key_words
            })
        });
        toin = arr
      }
      console.log(toin)
      this.keySearchIn = toin;
      this.keySearchOut = to.out || [];
    },
    datePicker: {
      deep: true,
      handler: function(n) {
        this.$parent.page.pageIndex = 1

        this.start = common.stampToTime(n[0])
        this.end = this.getDayEnd(n[1])
        this.changeTime()
      }
    }
  },
  methods: {
    delKeyWordIn(index) {
      let delBtn = document.querySelector('.centerFilter .filter .del')
      if(delBtn){
        delBtn.click()
      }
      this.keySearchIn.splice(index,1)
      let keySearchIn = []
      let keySearchOut = []

      this.keySearchIn.forEach(el => {
        keySearchIn.push(el)
      })
      // keySearchIn = keySearchIn.join(',')

      this.keySearchOut.forEach(el => {
        keySearchOut.push(el)
      })
      // keySearchOut = keySearchOut.join(',')

      let search_keywords = {}
      search_keywords.in = keySearchIn
      search_keywords.out = keySearchOut
      search_keywords = JSON.stringify(search_keywords)
      let newQ = JSON.parse(JSON.stringify(this.$route.query))
      newQ.k = ''
      this.$router.replace({
        query: newQ
      })
      this.$emit('searchKeywords',search_keywords)
    },
    delKeyWordOut(index) {
      console.log(this.keySearchOut)
      this.keySearchOut.splice(index,1)
      let keySearchIn = []
      let keySearchOut = []

      this.keySearchIn.forEach(el => {
        keySearchIn.push(el)
      })
      // keySearchIn = keySearchIn.join(',')

      this.keySearchOut.forEach(el => {
        keySearchOut.push(el)
      })
      // keySearchOut = keySearchOut.join(',')

      let search_keywords = {}
      search_keywords.in = keySearchIn
      search_keywords.out = keySearchOut
      search_keywords = JSON.stringify(search_keywords)
      this.$emit('searchKeywords',search_keywords)
    },
    calcExpendWidth(i,j) {

      console.log(i,j)

      setTimeout(() => {
        if(this.$refs[i]){

          let width = 0;
          let dom = this.$refs[i][0].querySelectorAll('.item');
          let length = dom.length;
          for (let index = 0; index < length; index++) {
            width += dom[index].getBoundingClientRect().width + 20            
          }

          console.log(width,this.$refs[i][0].getBoundingClientRect().width)

          if(width > this.$refs[i][0].getBoundingClientRect().width){
            console.log(887656)
            this.$refs[j][0].style.display = 'flex'
          }else{
            this.$refs[j][0].style.display = 'none'
          }
        }
      },300)
      
      

    },
    getDayEnd(s) {
      // 获取当天的结束时间
      if (!s) {
        return ''
      }

      const year = s.getFullYear()
      const month = common.doubleDigit(s.getMonth() + 1)
      const day = common.doubleDigit(s.getDate())

      return  `${year}-${month}-${day} 23:59:59`
    },
    checkEleHeight(items, expander) {
      // 为实现页面加载后检测是否有换行出现，只能操作dom。里面夹带了具体样式数值
      setTimeout(() => {
        let overflow = false
        const height = this.$refs[items][0].getBoundingClientRect().height
        if (height > 40) {
          overflow = true
        }
        if (overflow) {
          this.$refs[items][0].style.height = '30px'
          this.$refs[expander][0].style.display = 'flex'
        }
      }, 0)
    },
    openSet(t, i) {
      // 打开设置弹窗
      this.$refs.clueSources.open(t, i)
      .then((r) => {
        if (r) {
          this.getData().then((res) => {
            if (res) {
              this.$emit('filterData', {})
            }
          })
        }
      })
    },
    autoSelectTag() {
      // 自动选中标签（从详情页回来时）
      if (!this.selectedTag) return

      const tags = this.filters.filter(i => i.key === 'tags')[0].list
      let tag = {}
      tags.forEach(i => {
        if (this.selectedTag === i.title) {
          tag = i
        }
      })

      // this.selectItem(tag)
      this.$set(tag, 'selected', true)

      this.selectedTag = ''
    },
    getData() {
      // 获取接口数据
      let listSearch = this.list_search;
      console.log(listSearch)
      listSearch.forEach(el => {
        if(el.key == 'days'){
          this.hasDay = true
        }
      })

      listSearch = listSearch.filter(el => {
        return el.key != 'days'
      })

      listSearch = listSearch.filter(el => {
        return el.key != 'start'
      })

      listSearch = listSearch.filter(el => {
        return el.key != 'end'
      })

      this.filters = listSearch
      this.autoSelectTag()

      // const idstring = this.$route.params.id
      // const info = {
      //   source_type: this.type || '',
      //   idstring: idstring || ''
      // }

      // return common.myFetch(apis.clueFilters, info)
      // .then((res) => {
      //   if (res) {
      //     console.log(res)
      //     res.forEach(el => {
      //       if(el.key == 'days'){
      //         this.hasDay = true
      //       }
      //     })

      //     res = res.filter(el => {
      //       return el.key != 'days'
      //     })

      //     this.filters = res
      //     this.autoSelectTag()

      //     return res
      //   }
      // })
    },
    toggle() {
      // 切换显示过滤列表
      this.showFilters = !this.showFilters
    },
    delCate(c) {
      // 取消选中某一类及其子类
      this.$parent.page.pageIndex = 1

      c.list.forEach(i => {
        this.$set(i, 'selected', false)

        if (i.list) {
          i.list.forEach(s => {
            this.$set(s, 'selected', false)
          })
        }
      })

      this.$nextTick(() => {
        this.calculateSelected()
      })
    },
    delTimeData() {
      // 删除时间选择
      this.timeDayData = {
        title: '发布时间',
        list: []
      }

      if (this.start || this.end) {
        this.datePicker = ''
      } else {
        this.day = {}
        this.calculateSelected()
      }
    },
    selectItem(i,key) {
      // console.log(1111,i,key)
      // 选择筛选项
      this.$parent.page.pageIndex = 1

      this.$refs[key][0].scrollTop = 0;

      this.$set(i, 'selected', !i.selected)
      this.$nextTick(() => {
        if (!i.selected) {
          if (i.list) {
            i.list.map(i => {
              this.$set(i, 'selected', false)
            })
          }
        }

        this.calculateSelected()
      })
    },
    selectDay(d) {
      this.$parent.page.pageIndex = 1

      if (d.key === this.day.key) {
        this.day = {}
      } else {
        this.day = d
      }

      this.calculateSelected()
    },
    changeTime() {
      this.calculateSelected()
    },
    addTimeData(n) {
      const timeObj = {
        days: '',
        start: '',
        end: ''
      }

      const timeFilterObj = {
        title: '发布时间',
        list: []
      }

      if (this.day.key) {
        timeObj.days = this.day.key || ''

        const dayTitle = this.day.title
        const dayObj = {
          title: dayTitle,
          selected: true
        }
        timeFilterObj.list.push(dayObj)
      }

      if (this.start || this.end) {
        timeObj.start = this.start
        timeObj.end = this.end

        const dayObj = {
          title: `${timeObj.start.split(' ')[0]}~${timeObj.end.split(' ')[0]}`,
          selected: true
        }
        timeFilterObj.list.push(dayObj)
      }

      this.timeDayData = timeFilterObj
      Object.assign(this.filterOptions, timeObj)
    },
    changeExpand(c, key) {
      // 切换类目展开／收起
      this.$set(c, 'expand', !c.expand)

      this.$nextTick(() => {
        if (!c.expand) {
          this.$refs[key][0].scrollTop = 0
        }
      })
    },
    calculateSelected() {
      // 计算已选项
      this.filters.forEach(i => {
        const selected1 = [] // 一级已选
        let selected2 = [] // 二级已选
        let key2 = ''
        i.list.forEach(c => {
          if (c.selected) {
            selected1.push(c.id || c.key)
          }

          if (c.list) {
            const subSelected = []
            key2 = c.key
            c.list.forEach( s => {
              if (s.selected) {
                subSelected.push(s.id)
              }
            })
            selected2 = selected2.concat(subSelected)
          }
        })

        this.filterOptions[i.key] = selected1.join(',')
        if (key2) this.filterOptions[key2] = selected2.join(',')
      })

      this.addTimeData()
      this.postData()
    },
    postData() {
      // 传递过滤
      this.$parent.list = null
      this.$emit('filterData', this.filterOptions)
    }
  },
  mounted() {
    this.selectedTag = this.$route.params.tag
    this.listSearch = this.list_search;
    this.getData()
    window.addEventListener('resize',() => {
      this.filters.forEach((el,key) => {
        this.calcExpendWidth(`items${key}`, `expander${key}`)
      })
    })
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.label {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  color: @green;
  font-weight: bold;
  word-break: keep-all;
}

.gray {
  color: @sub !important;
}

.clueFilter {
  padding: 20px 30px;

  &.bottom {
    padding-bottom: 25px;
    box-sizing: border-box;
  }
  .boxOuter;
  .headline {
    display: flex;
    overflow: hidden;
    .label {
      .label;
      width: 40px;
      flex-shrink: 0;
    }
    .cates {
      flex: 1;
      margin-bottom: -10px;
      display: flex;
      flex-wrap: wrap;
      .cateWrapper {
        display: flex;
        flex-wrap: wrap;
      }
      .cate {
        margin: 0 0 10px 10px;
        width: auto;
        max-width: 240px;
        height: 30px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        background-color: rgba(185, 195, 195, 0.2);
        border-radius: 4px;
        .type {
          white-space: nowrap;
          color: @sub;
          flex: 1;
          font-size: 13px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        img {
          cursor: pointer;
          margin-left: 8px;
        }
      }
    }
    .toggler {
      flex-shrink: 0;
      width: 120px;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 4px;
      border: 1px solid @dc;
      padding: 0 10px;
      background-color: rgba(185, 195, 195, .2);
      font-size: 14px;
      color: @sub;
      margin-left: 10px;
      cursor: pointer;
      font-weight: bold;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: #f0f0f0;
    margin: 10px 0 20px;
  }
  .filters {
    .mb_20 {
      // margin-bottom: 10px;
    }
    .mb_20_new {
      margin-bottom: 20px;
    }
    .pb_20 {
      padding-bottom: 10px;
    }
    .filter {
      display: flex;
      position: relative;
      .label {
        .label;
        min-width: 56px;
        margin-right: 30px;
        text-align-last: justify;
      }
      .items {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        // height: auto;
        // height: 40px;
        // min-height: 40px;
        height: 50px;
        min-height: 50px;
        max-height: 90px;
        overflow: hidden;
        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 2px;
        }
        .item {
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 100px;
          border: 1px solid transparent;
          padding: 0 6px;
          width: auto;
          white-space: nowrap;
          // min-width: 80px;
          flex-basis: 80px;
          // overflow: hidden;
          // text-overflow: ellipsis;
          word-break: keep-all;
          // margin: 0 10px 10px 0;
          margin: 0 10px 20px 0;
          font-size: 14px;
          color: @sub;
          cursor: pointer;
        }
        .active {
          color: @green;
          border-color: @green;
        }
      }
      .overflow {
        flex-wrap: wrap;
        height: auto !important;
        overflow-y: auto;
      }
      .expander {
        width: 30px;
        height: 30px;
        border: 1px solid @dc;
        border-radius: 2px;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .set {
        width: 50px;
        height: 30px;
        border: 1px solid @dc;
        background-color: rgba(185, 195, 195, 0.2);
        border-radius: 2px;
        color: @sub;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        margin: 0 0 10px 10px;
        cursor: pointer;
        font-weight: bold;
      }
      .seperator {
        bottom: 0;
        right: 0;
        width: calc(100% - 52px);
        height: 1px;
        // margin-left: 52px;
        background-color: #f0f0f0;
        position: absolute;
      }
    }
  }
}

</style>
